module.exports = __webpack_public_path__ + "media/images/icons/twitter_blue-430cacf1b564d36d5ce9a0af667a2dee.svg";